import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import ButtonPrimary from "../../../elements/button/ButtonPrimary";
import SMModal from "../../../elements/modals/SMModal";
import axiosAPI from "../../../utils/axios-api";

const API = process.env.REACT_APP_API;
const EditKuesionerFile = () => {
  const history = useHistory();
  const {idKuesioner} = useParams()
  // const [selectedFile, setselectedFile] = useState(null);
  const [namaFile, setnamaFile] = useState(null);
  const [modalSimpan, setmodalSimpan] = useState(false);
  const [statusSimpan, setstatusSimpan] = useState(0);
  const [kuesioner, setkuesioner] = useState({});
  const [number, setnumber] = useState(0);

  useEffect(() => {
    getData()
    let nama_file = localStorage.getItem("temp_edit_file") ?? null;
    let tempKuesioner = JSON.parse(
      localStorage.getItem("temp_edit_kuesioner")
    );

    if (!!tempKuesioner) {
      setkuesioner(tempKuesioner);
    }

    setnamaFile(nama_file);
  }, []);

  function getData(params) {
    axiosAPI.get(API + "kuesioner/" + idKuesioner + "?include=dataSoal")
    .then(res => {
      let data = res.data.data
      let dataSoal = data.relationships.dataSoal
      setnamaFile(dataSoal.substring(dataSoal.lastIndexOf("/") + 1, dataSoal.length))
    })
  }

  function onFileChange(params) {
    // await setselectedFile(params.target.files[0]);
    onFileUpload(params.target.files[0]);
  }

  function onFileUpload(params) {
    const formData = new FormData();

    formData.append("file", params);

    axiosAPI.post(API + "file/upload/soal", formData).then((res) => {
      console.log(res);
      if (res.data.status === "success") {
        setnamaFile(res.data.data.nama_file);
        localStorage.setItem("temp_edit_file", res.data.data.nama_file);
      }
    });
  }

  function countDown(params) {
    let number = params ?? 3;
    setnumber(params);
    if (number > 0) {
      setInterval(() => {
        number = number - 1;
        if (number >= 0) {
          setnumber(number);
        }
      }, 1000);
    }
  }

  function create(params) {
    // status simpan
    // 0 = IDLE
    // 1 = SUCCEDDED
    // 2 = FAILED
    // 3 = ON_PROCCESS
    let body = {
      info_panduan: kuesioner,
      file: namaFile,
    };
    setstatusSimpan(3);
    axiosAPI
      .post(API + "kuesioner/"+idKuesioner+"/edit-file", body)
      .then((res) => {
        if (res.data.status === "success") {
          setstatusSimpan(1);
          localStorage.removeItem("temp_edit_file");
          localStorage.removeItem("temp_edit_kuesioner");
          localStorage.removeItem("queue_edit_kuesioner");
          countDown(3);
          setTimeout(() => {
            window.location.replace("/daftar-kuesioner")
          }, 3000);
        } else {
          setstatusSimpan(2);
          localStorage.setItem(
            "queue_edit_kuesioner",
            JSON.stringify({
              kuesioner: "temp_edit_kuesioner",
              type: "file",
            })
          );
        }
      })
      .catch((err) => {
        setstatusSimpan(2);
        localStorage.setItem(
          "queue_edit_kuesioner",
          JSON.stringify({
            kuesioner: "temp_edit_kuesioner",
            type: "file",
          })
        );
      });
  }

  function viewModalSimpan(params) {
    if (statusSimpan === 3) {
      return (
        <div className="p-4">
          <p>Sedang menyimpan data ...</p>
        </div>
      );
    } else if (statusSimpan === 2) {
      return (
        <div className="p-4">
          <p>Gagal menyimpan data</p>
          <div className="flex flex-row py-6 gap-2">
            <button
              onClick={() => create()}
              className="flex flex-row items-center rounded px-4 py-2 bg-blue-400 text-white"
            >
              Ulangi
            </button>
          </div>
        </div>
      );
    } else if (statusSimpan === 1) {
      return (
        <div className="p-4">
          <p>
            Berhasil menyimpan data, anda akan dialihkan ke halaman daftar
            kuesioner dalam {number} detik
          </p>
          <div className="flex flex-row py-6 gap-2"></div>
        </div>
      );
    }
    return (
      <div className="p-4">
        <p>Simpan data anda</p>
        <div className="flex flex-row py-6 gap-2">
          <button
            onClick={() => setmodalSimpan(!modalSimpan)}
            className="flex flex-row items-center rounded px-4 py-2 bg-red-400 text-white"
          >
            Batal
          </button>
          <button
            onClick={() => create()}
            className="flex flex-row items-center rounded px-4 py-2 bg-blue-400 text-white"
          >
            Ya
          </button>
        </div>
      </div>
    );
  }
  return (
    <>
      <SMModal
        title="Konfirmasi"
        show={modalSimpan}
        onClose={() => setmodalSimpan(!modalSimpan)}
      >
        {viewModalSimpan()}
      </SMModal>
      <div
        className="w-full flex flex-col dark:text-white pt-16"
        style={{ minHeight: "100vh" }}
      >
        <div className="flex flex-col w-4/12 border border-gray-300 dark:border-gray-700 rounded-lg p-10 shadow-xl">
          <h1 className="text-xl font-bold">EDIT KUESIONER - FILE</h1>

          <div className="my-4">
            <h className="text-lg font-medium">File: {namaFile}</h>
            <div className="flex flex-row items-center gap-4">
              <div>
                <input
                  type="file"
                  accept="application/pdf"
                  name="file"
                  id="file"
                  className="none"
                  style={{ display: "none" }}
                  onChange={(e) => onFileChange(e)}
                />
                <label
                  className="cursor-pointer px-4 py-2 rounded text-white bg-blue-500"
                  htmlFor="file"
                  for="file"
                >
                  Upload Baru
                  {/* <ButtonPrimary text="Upload File" type="solid" /> */}
                </label>
              </div>

              <div>
                {!!namaFile ? (
                  <ButtonPrimary
                    onClick={() => setmodalSimpan(!modalSimpan)}
                    text="Simpan"
                    type="solid"
                  />
                ) : (
                  <button className="flex px-4 py-2 rounded-lg bg-gray-300">
                    Simpan
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditKuesionerFile;
